var FacebookPageBuilder = /** @class */ (function () {
    function FacebookPageBuilder() {
        this.facebookPage = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            token: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            picture: 'https://graph.facebook.com/v2.5/b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b/picture',
            category: 'bob',
            name: 'bobi'
        };
    }
    FacebookPageBuilder.prototype.withId = function (id) {
        this.facebookPage.id = id;
        return this;
    };
    FacebookPageBuilder.prototype.withToken = function (token) {
        this.facebookPage.token = token;
        return this;
    };
    FacebookPageBuilder.prototype.withPicture = function (picture) {
        this.facebookPage.picture = picture;
        return this;
    };
    FacebookPageBuilder.prototype.withCategory = function (category) {
        this.facebookPage.category = category;
        return this;
    };
    FacebookPageBuilder.prototype.withName = function (name) {
        this.facebookPage.name = name;
        return this;
    };
    FacebookPageBuilder.prototype.build = function () {
        return this.facebookPage;
    };
    return FacebookPageBuilder;
}());
export { FacebookPageBuilder };
;
//# sourceMappingURL=facebook-page-builder.js.map